import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import classNames from 'classnames';

import * as Styles from './TabMenu.styles';

const TabMenu = ({
  options,
  onChange,
  defaultValue = 1,
  nowrap,
  className,
  buttonGroupClassName,
  urlImage = '',
  isFollowCompany = false,
  handleFollowCompany,
}) => {
  const [value, setValue] = useState(defaultValue || options[1].value);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (item) => {
    setValue(item.value);
    if (onChange) {
      onChange(item);
    }
  };

  return (
    <Styles.Wrapper className={classNames(className)}>
      <Styles.ButtonGroup
        variant="contained"
        className={classNames(buttonGroupClassName)}
      >
        <div className="flex">
          {urlImage ? (
            <div
              className="w-10 h-10 rounded-md mr-4 bg-100% bg-white bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${urlImage})` }}
            ></div>
          ) : null}

          {options.map((item) => (
            <Button
              key={item.value}
              onClick={() => handleChange(item)}
              className={classNames(
                value === item.value ? 'active' : '',
                nowrap ? 'whitespace-nowrap' : ''
              )}
            >
              {item.label}
            </Button>
          ))}
          {handleFollowCompany ? (
            <Button
              className={classNames(nowrap ? 'whitespace-nowrap' : '')}
              onClick={() => handleFollowCompany()}
            >
              {isFollowCompany ? 'Huỷ theo dõi' : 'Theo dõi'}
            </Button>
          ) : null}
        </div>
      </Styles.ButtonGroup>
    </Styles.Wrapper>
  );
};

export default TabMenu;
